import script from "./AddRelayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddRelayer.vue?vue&type=script&setup=true&lang=ts"

import "./AddRelayer.vue?vue&type=style&index=0&id=38e8d6d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e8d6d4"]])

export default __exports__